import { Types } from '@store/types';

const initialState = [];

const StyleNumberReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_ORDER_STYLE_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default StyleNumberReducer;
